import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container, TextField, Button, IconButton } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField, entitySelectField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { upsertPerson } from '../../../actions/person/personUpsert'
import { PersonDetailState } from '../../../reducers/person/personDetail'
import Person from '../../../models/Person'
import { literalStrings, toPascalCase } from '../../../utils/StringUtils';
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { personTypeToDescription, visiblePersonTypes } from '../../Client/Profile'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchPerson } from '../../../actions/person/personDetail'
import { BackButton } from '../../Utils/BackButton'
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab'
import AdapterMoment from '@mui/lab/AdapterMoment'
import moment, { Moment } from 'moment'
import { useThemeContext } from '../../../theme/ThemeContext'
import { GeneralDescState } from '../../../reducers/generalDescList'
import Selector from '../../Selector'
import { CountriesState } from '../../../reducers/country/countries'
import { ClearOutlined, RecentActorsOutlined } from '@mui/icons-material'
import { LinkedVendorsDialog } from './LinkedVendors'
import { VendorListState } from '../../../reducers/vendor/vendorList'
import { LinkedVendorsListState } from '../../../reducers/person/linkedVendorsList'
import { fetchVendors } from '../../../actions/vendor/vendorList'
import { fetchLinkedVendors } from '../../../actions/person/linkedVendorsList'
import { isNil } from 'ramda'
import { isAdmin, isClient, isManager, SessionState } from '../../../reducers/auth/session'
import { ProvincesState } from '../../../reducers/province/provinces'
import { checkEmailExists } from '../../../actions/person/personList'

interface Props {
  person: PersonDetailState
  generalDesc: GeneralDescState
  countries: CountriesState
  provinces: ProvincesState
  vendorList?: VendorListState
  linkedVendors?: LinkedVendorsListState
  session: SessionState
}

const empty: Person = {
  id: null,
  firstName: '',
  lastName: '',
  phoneNumber: '',
  documentNumber: '',
  documentType: '',
  province: '',
  address: '',
  zipCode: '',
  locality: '',
  position: '',
  email: '',
  personType: '',
  byPersonTypeId: 0,
  categoryId: 0,
  category: '',
  countryId: 0,
  country: '',
  fullName: '',
  expiredDate: '',
  orionId: null,
  regionTag: '',
  allowAddDeliveryLocation: false
}

const PersonUpsert: React.FC<Props> = ({ person, generalDesc, countries, provinces, vendorList, linkedVendors, session }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [personInfo, setPersonInfo] = useState<Person>(person.person || {
    ...empty, personType: isClient(session) ? 'C' : '',
    regionTag: session.isChaco ? 'Chaco' : '',
    byPersonTypeId: isClient(session) ? session.byPersonTypeId : 0
  })
  const [category, setCategory] = useState(person.person?.category || '')
  const [regionTag, setRegionTag] = useState(person.person ? person.person?.regionTag !== null && person.person?.regionTag !== '' ? person.person?.regionTag : session.isChaco ? 'Chaco' : 'General' : session.isChaco ? 'Chaco' : 'General')
  const [country, setCountry] = useState(person.person?.country || '')
  const [province, setProvince] = useState(person.person?.province || '')
  const [showLinkedVendorsDialog, setShowLinkedVendorsDialog] = useState<boolean>(false)
  const [emailError, setEmailError] = useState<string>("")

  const { t } = useTranslation('person')
  const { theme } = useThemeContext()
  const dispatch = useDispatch()
  const params = useParams<{ personId: string }>()
  const history = useHistory()
  const location = useLocation()

  console.log(session)
  console.log('personInfo', personInfo)
  console.log('person.person', person.person);
  console.log('regionTag', regionTag)

  useEffect(() => {
    if (params.personId) {
      dispatch(fetchPerson(params.personId))
    }
  }, [dispatch, params.personId])

  useEffect(() => {
    if (params.personId && (personInfo.personType === 'H' || personInfo.personType === 'V')) {
      dispatch(fetchLinkedVendors(`?personId=${params.personId}`))
    }
  }, [dispatch, params.personId, personInfo.personType])

  useEffect(() => {
    if (personInfo.personType === 'H' || personInfo.personType === 'V')
      dispatch(fetchVendors('?all=true'))
  }, [dispatch, personInfo.personType])


  useEffect(() => {
    if (session.isChaco && regionTag !== 'Chaco') {
      setRegionTag('Chaco')
      setPersonInfo(prev => ({
        ...prev,
        regionTag: 'Chaco'
      }))
    }
  }, [session.isChaco, regionTag])

  const change = (newPersonInfo: Person) => {
    setPersonInfo(newPersonInfo)
    setChanged(true)
  }

  const changePerson = async (event: FormEvent) => {
    event.preventDefault()
    try {
      setEmailError("")
      if (personInfo.email) {
        const exists = await new Promise<boolean>((resolve) => {
          dispatch(
            checkEmailExists(personInfo.email, personInfo.id, (answer: boolean) => {
              resolve(answer)
            })
          )
        })

        if (exists) {
          setEmailError(t("emailAlreadyExists"))
          return
        }
      }
      setChanged(false)
      await dispatch(upsertPerson(personInfo))
      setChanged(false)
      if (location.state)
        (location.state as any).update = !(location.state as any).update
      history.goBack()
    }
    catch {
    }
  }

  const setDataCategory = (description: any): number | null => {
    if (description) {
      setCategory(description)
      return generalDesc.generalDesc?.find((category) => category.description === description)?.id || 0
    }
    return null
  }


  const setDataProvince = (description: any): number | null => {
    if (description) {
      setProvince(description)
      return provinces.provinces?.find((province) => province.descripcion.toUpperCase() === description.toUpperCase())?.codigo_provincia || 0
    }
    return null
  }

  const setDataCountry = (description: any): number | null => {
    if (description) {
      setCountry(description)
      return countries.countries?.find((country) => country.description === description)?.id || 0
    }
    return null
  }

  const updateRegionTag = (e: any) => {
    let description = e.target.value
    setRegionTag(description)
    if (description === 'General')
      description = ''
    setPersonInfo({ ...personInfo, regionTag: description })
    setChanged(true)
  }

  const updateCategory = (e: any) => {
    const description = e.target.value
    const categoryId = setDataCategory(description)
    if (categoryId) {
      setPersonInfo({ ...personInfo, categoryId: categoryId })
      setChanged(true)
    }
  }

  const updateCountry = (e: any) => {
    const description = e.target.value
    const countryId = setDataCountry(description)
    if (countryId) {
      setPersonInfo({ ...personInfo, countryId: countryId })
      setChanged(true)
    }
  }

  const updateProvince = (e: any) => {
    const description = e.target.value
    setDataProvince(description)
    if (description) {
      setPersonInfo({ ...personInfo, province: description })
      setChanged(true)
    }
  }

  const updateAllowAddDL = (e: any) => {
    const description = e.target.value
    setPersonInfo({ ...personInfo, allowAddDeliveryLocation: description === true })
    setChanged(true)
  }

  const updateDate = (newDate: Moment | null) => {
    if (newDate) {
      const expiredDate = newDate.tz("America/Argentina/Buenos_Aires").format()
      setPersonInfo({ ...personInfo, expiredDate })
    }
    else setPersonInfo({ ...personInfo, expiredDate: '' })
    setChanged(true)
  }

  useEffect(() => {
    if (person.person) {
      setPersonInfo(params.personId ? person.person :
        {
          ...empty, personType: isClient(session) ? 'C' : '',
          byPersonTypeId: isClient(session) ? session.byPersonTypeId : 0
        }
      )
      setCategory(params.personId ? person.person?.category : '')
      setCountry(params.personId ? person.person?.country : '')
      setProvince(params.personId ? person.person?.province : '')
      setRegionTag(params.personId ? person.person?.regionTag !== null && person.person?.regionTag !== '' ? person.person?.regionTag : session.isChaco ? 'Chaco' : 'General' : session.isChaco ? 'Chaco' : 'General')
    }
  }, [person.person, params.personId, session])


  const categoryList = () => {
    const list = generalDesc.generalDesc?.filter((category) => (category.active))
    return list ? [...list.map(it => it.description), ''] : []
  }

  const regionTagList = () => {
    return ['General', 'Chaco', 'Exterior']
  }

  const provinceList = () => {
    const list = provinces.provinces
    return list ? [...list.map(it => it.descripcion !== 'CABA' ? toPascalCase(it.descripcion) : it.descripcion), ''] : []
  }

  const countryList = () => {
    const list = countries.countries?.filter((country) => (country.active))
    return list ? [...list.map(it => it.description), ''] : []
  }

  const PersonInfoField = useMemo(() => entityTextField(change), [])

  const PersonInfoSelectField = useMemo(() => entitySelectField(change), [])

  const translatePersonTypeDescription = (value: string): string => t(personTypeToDescription(value))

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={t('title')} />
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changePerson}>
            {[
              literalStrings(t("firstName"), "firstName"),
              literalStrings(t("lastName"), "lastName"),
              //literalStrings(t("address"), "address"),
            ].map(([label, attr], i) =>
              <PersonInfoField
                key={i}
                variant="outlined"
                label={label}
                entity={personInfo}
                attr={attr}
                size="small"
                required
              />)
            }
            {/*
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <PersonInfoField
                key="zipCode"
                variant="outlined"
                label={t("zipCode")}
                entity={personInfo}
                attr="zipCode"
                size="small"
                style={{ maxWidth: "150px", marginRight: "10px" }}
                required
              />
              <PersonInfoField
                key="locality"
                variant="outlined"
                label={t("locality")}
                entity={personInfo}
                attr="locality"
                size="small"
                required
              />
            </Stack>
            */}
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              {/*
              <PersonInfoField
                key="province"
                variant="outlined"
                label={t("province")}
                entity={personInfo}
                attr="province"
                size="small"
                style={{ maxWidth: "550px", marginRight: "10px" }}
                required
              />*/}
              <Selector
                key="province"
                label={t("province")}
                menuItems={provinceList()}
                onChange={updateProvince}
                value={province}
                size="small"
                style={{ width: '100%', marginRight: "10px" }}
                required
              />
              <Selector
                key="country"
                label={t("country")}
                menuItems={countryList()}
                onChange={updateCountry}
                value={country}
                size="small"
                style={{ width: '100%' }}
                required
              />
            </Stack>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <PersonInfoField
                key="phoneNumber"
                variant="outlined"
                label={t("phoneNumber")}
                entity={personInfo}
                attr="phoneNumber"
                size="small"
                style={{ maxWidth: "550px", marginRight: "10px" }}
                required
              />
              <PersonInfoField
                key="documentNumber"
                variant="outlined"
                label={t("documentNumber")}
                entity={personInfo}
                attr="documentNumber"
                size="small"
                required
              />
            </Stack>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <PersonInfoField
                key="position"
                variant="outlined"
                label={t("position")}
                entity={personInfo}
                attr="position"
                size="small"
                required
              />
            </Stack>
            <PersonInfoField
              label={t('email')}
              variant="outlined"
              size='small'
              type='email'
              entity={personInfo}
              attr="email"
              required
              error={!!emailError}
              helperText={emailError}
            />
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <PersonInfoSelectField
                key="personType"
                label={t("personType")}
                entity={personInfo}
                attr="personType"
                menuItems={visiblePersonTypes.filter(value => isAdmin(session) || (isManager(session) && value !== 'A') || value === 'C')}
                size='small'
                textAdapter={translatePersonTypeDescription}
                style={{ width: "200px", marginRight: "10px" }}
                required
              />
              <PersonInfoField
                key="byPersonTypeId"
                variant="outlined"
                label={t("byPersonTypeId")}
                entity={personInfo}
                attr="byPersonTypeId"
                size='small'
                style={{ width: "200px" }}
                required={personInfo.personType in ['C', 'P']}
                disabled={isClient(session) || (personInfo.personType !== 'C' && personInfo.personType !== 'P')}
              />
              {!isClient(session) && <Selector
                key="allowAddDeliveryLocation"
                label={t("allowAddDeliveryLocation")}
                style={{ width: "300px", marginLeft: "10px" }}
                size="small"
                value={isNil(personInfo.allowAddDeliveryLocation) ? "" : Boolean(personInfo.allowAddDeliveryLocation)}
                textAdapter={(_value) => Boolean(_value) ? t("yes") : t("no")}
                onChange={updateAllowAddDL}
                menuItems={[true, false]}
                required={personInfo.personType in ['C', 'P']}
                disabled={personInfo.personType !== 'C' && personInfo.personType !== 'P'}
              />}
              {!isClient(session) && !session.isChaco && 
                <PersonInfoField
                  label={t('orionId')}
                  variant="outlined"
                  size='small'
                  type='tel'
                  style={{ width: "200px", marginLeft: "10px" }}
                  entity={personInfo}
                  attr="orionId"
                  disabled={personInfo.personType === 'C'}
                />}

              {!isClient(session) &&
                <Selector
                  key="regionTag"
                  label={t("region")}
                  menuItems={regionTagList()}
                  onChange={updateRegionTag}
                  value={regionTag}
                  size='small'
                  style={{ width: "200px", marginLeft: "10px" }}
                  disabled={session.isChaco ? true : false}
                />}
            </Stack>

            {!isClient(session) && <Stack display="flex" flexDirection="row" flexGrow={1} >
              <Selector
                key="category"
                label={t("category")}
                menuItems={categoryList()} // generalDescList()}
                onChange={updateCategory}
                value={category}
                size='small'
                style={{ marginRight: "10px", width: '100%' }}
                required={personInfo.personType === 'S'}
                disabled={personInfo.personType !== 'S' && personInfo.personType !== 'H' && personInfo.personType !== 'M'}
              />
              {category && (
                <IconButton
                  size="small"
                  aria-label="clear category"
                  disabled={personInfo.personType !== 'S' && personInfo.personType !== 'H' && personInfo.personType !== 'M'}
                  onClick={() => {
                    setCategory('')
                    setPersonInfo({ ...personInfo, categoryId: 0 })
                    setChanged(true)
                  }}
                >
                  <ClearOutlined fontSize="small" />
                </IconButton>
              )}
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  label={t("expired")}
                  inputFormat="DD/MM/yyyy"
                  renderInput={(params) => <TextField sx={{ marginTop: "15px", maxWidth: 200, svg: { fill: theme.typography.button.color } }} {...params} size='small' />}
                  value={personInfo.expiredDate ? moment(new Date(personInfo.expiredDate)) : null}
                  onChange={updateDate}
                />
              </LocalizationProvider>
            </Stack>}
            <Stack display="flex" flexDirection='row' justifyContent="space-between">
              <BackButton />
              {personInfo.id && (personInfo.personType === 'H' || personInfo.personType === 'V') && <Button color="success" variant="contained" style={{ textTransform: 'none' }}
                startIcon={<RecentActorsOutlined />} onClick={(e) => { e.stopPropagation(); setShowLinkedVendorsDialog(true) }}>{t('linkedVendors')}</Button>}
              <ProgressButton state={person} disabled={!changed}>
                {t('save')}
              </ProgressButton>
            </Stack>
            {showLinkedVendorsDialog && <LinkedVendorsDialog
              onCancel={() => setShowLinkedVendorsDialog(false)}
              personId={personInfo.id!}
              vendorList={vendorList}
              linkedVendors={linkedVendors}
              onConfirm={() => setShowLinkedVendorsDialog(false)}
            />}

          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  person: state.personDetail,
  generalDesc: state.generalDescList,
  vendorList: state.vendorList,
  linkedVendors: state.linkedVendorsList,
  countries: state.countries,
  provinces: state.provinces,
  session: state.session
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(PersonUpsert)
